export default __webpack_public_path__ + "static/media/SolverEDGE-Main.23bc1d31.png";